module.exports = __webpack_public_path__ + "be8defec911d312a.svg";